import React from 'react';
import {
  Dialog,
  DialogSurface,
  DialogBody,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Text,
  Spinner,
} from '@fluentui/react-components';
import { DismissRegular } from '@fluentui/react-icons';

interface CreateUsersDialogProps {
  isOpen: boolean;
  onClose: () => void;
  hasValidMappings: boolean;
}

const CreateUsersDialog: React.FC<CreateUsersDialogProps> = ({
  isOpen,
  onClose,
  hasValidMappings,
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={(_, data) => !data.open && onClose()}>
      <DialogSurface>
        <DialogBody>
          <DialogTitle
            action={
              <Button appearance="subtle" icon={<DismissRegular />} onClick={onClose} />
            }
          >
            Skapa användare
          </DialogTitle>
          <DialogContent>
            {hasValidMappings ? (
              <div className="flex items-center gap-2">
                <Spinner size="small" />
                <Text>Skapar användare...</Text>
              </div>
            ) : (
              <Text>
                Kan inte skapa användare utan "Kontakt Koppling Föreståndare" kopplingar
              </Text>
            )}
          </DialogContent>
          {!hasValidMappings && (
            <DialogActions>
              <Button appearance="primary" onClick={onClose}>Stäng</Button>
            </DialogActions>
          )}
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};

export default CreateUsersDialog;
